module.exports = __webpack_public_path__ + "img/unihack_logo.c6ab25d9.png";